
<style lang="scss" scope>
.ivu-mt,
.ivu-mt-16 {
  margin-top: 16px !important;
}

.items-center {
  align-items: center;
}

.justify-between {
  justify-content: space-between;
}

.flex {
  display: flex !important;
  width: 100%;
}

.flex-warp {
  flex-wrap: wrap;
}

.mr1 {
  margin-right: 1rem;
  word-wrap: +break-word;
  word-break: +norm;
}

.flexs {
  display: flex !important;
  width: 15%;
}
</style>

<template>
  <el-card shadow="never" class="l-main-card">
    <div class="l-table-toolbar">
      <div class="flex flex-warp">
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">用户Id：</p>
          <el-input placeholder="请输入员工Id" v-model="search_data.app_user_id" class="input-with-select" style="width: 76%;">
            <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
          </el-input>
        </div>
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">员工名：</p>
          <el-input placeholder="请输入员工名" v-model="search_data.admin_name" class="input-with-select" style="width: 76%;">
            <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
          </el-input>
        </div>
        <!-- <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">所属APP：</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.app_type" placeholder="全部" clearable @change="changes" style="width: 100%;">
              <el-option v-for="item in app_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
        </div> -->
        <!-- <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">代充公会：</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.sociaty_id" placeholder="全部" clearable @change="changes" style="width: 100%;">
              <el-option v-for="item in sociaty_list" :key="item.id" :label="item.name" :value="item.id_s"></el-option>
            </el-select>
          </div>
        </div> -->
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">所属公司：</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.corp_id" placeholder="全部" clearable @change="changes" style="width: 100%;">
              <el-option v-for="item in corp_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
        </div>
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">所属部门：</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.depart_id" placeholder="全部" clearable @change="changes">
              <el-option v-for="item in depart_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
        </div>
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">所属小组：</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.group_id" placeholder="全部" clearable @change="changes">
              <el-option v-for="item in group_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
        </div>
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">日期：</p>
          <div class="l-show-more-search">
            <el-date-picker v-model="value2_check" style="width: 100%;" type="datetimerange" @blur="onPick_check(false)"
              start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
              @change="onPick_check(false)"></el-date-picker>
          </div>
        </div>
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1"></p>
          <div class="l-show-more-search" style="width: 76%;">
            <el-button type="default" icon="el-icon-refresh" @click="clearSearch">重置</el-button>
          </div>
        </div>
        <div class="flexs items-center ivu-mt ivu-mr">
          <el-tag class="marginRB10">总充值金额 ¥： <span>{{ this.total }} 元 </span></el-tag>
          <el-tag class="marginRB10">总充值金币 ¥： <span>{{ this.total_coin }} 币 </span></el-tag>
        </div>
      </div>
    </div>
    <div class="l-primary l-table-config" style=" border-bottom: solid 1px #e4e7ed;">
      <el-popover placement="bottom-start" width="200" trigger="click" popper-class="l-table-column-fixed-select-box">
        <span slot="reference">
          <i class="el-icon-setting"></i>表格列表配置
        </span>
        <div class>
          <div class="l-flex l-flex-just-between" style="margin-bottom:10px">
            <div>
              表格列表配置
              <i class="el-icon-refresh-left" style="float:right;  color: red;margin: 3px;"
                @click="resetFixedCheck">重置</i>
            </div>
          </div>
          <el-divider class="l-table-column-fixed-title-divider"></el-divider>
          <el-checkbox-group v-model="fixed_list">
            <div v-for="(item, Id) in this.columnsList" :key="Id">
              <el-checkbox :label="item.prop" style="margin-bottom:4px">{{ item.label }}</el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
      </el-popover>
    </div>
    <l-table :data="data" v-loading="loading" row-key="id">
      <el-table-column v-for="(item, index) in columns" :key="index" v-bind="{ ...item }" style="height: 100px;"
        :label="item.label" show-overflow-tooltip>
        <template v-slot="{ row }">
          <!-- <template v-if="item.prop == 'AppId'">{{ APP_TYPE[row.AppId] }}</template>
          <template v-else>{{ row[item.prop] }}</template> -->
          <template>{{ row[item.prop] }}</template>
        </template>
      </el-table-column>
    </l-table>

    <!--分页-->
    <l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size"
      :current-page.sync="page"></l-page>

    <!--详情-->
    <!-- <l-dialog :visible.sync="info_visible" title="详情" width="1200px">
                  <l-logs-info :visible.sync="info_visible" :row="info_row" />
                </l-dialog> -->

  </el-card>
</template>

<script>
import Vue from "vue";
import { APP_TYPE, PAY_TYPE } from "../appUser/state";
export default {
  name: "l-appUser-sociaty",
  components: {

  },
  // computed: {
  //   hasId() {
  //     return this.$props.info_app_user_id !== null;
  //   },
  // },
  data() {
    return {
      box: 1,
      data: [],
      count: 0,
      page: 1,
      total_coin: 0,
      total: 0,
      page_size: Vue.$_config.page.page_size,
      loading: false,

      info_visible: false, //是否显示编辑
      info_row: 0,
      APP_TYPE: APP_TYPE,
      PAY_TYPE: PAY_TYPE,
      //搜索
      search_visible: false,
      site_list: [],
      search_data: {
        app_user_id: "",
        // info_app_user_id : "",
        admin_name: "",
        app_type: "",
        start_time: "",
        end_time: "",
        corp_id: "",
        depart_id: "",
        group_id: "",
        sociaty_id: ""
      },
      rel_search_data: {},
      show_more_search: false,
      value2: "",
      value2_check: "",
      corp_list: [],
      depart_list: [],
      group_list: [],
      app_list: [],
      sociaty_list: [],
      re_fixed_list: [
        // "sociaty",
        "give_gift_user_DisplayId",
        "give_gift_user_name",
        "admin_name",
        "coin",
        "DisplayId",
        "app_user_name",
        "add_time_new",
      ],
      fixed_list: [
        // "sociaty",
        "give_gift_user_DisplayId",
        "give_gift_user_name",
        "admin_name",
        "coin",
        "DisplayId",
        "app_user_name",
        "add_time_new",
      ],
      columnsList: [
        // {
        //   prop: "sociaty",
        //   label: "代充公会",
        //   minWidth: "80",
        // },
        {
          prop: "give_gift_user_DisplayId",
          label: "代充人ID",
          minWidth: "90"
        },
        {
          prop: "give_gift_user_name",
          label: "代充人昵称",
          minWidth: "80"
        },
        {
          prop: "depart_name",
          label: "员工部门",
          minWidth: "100"
        },
        {
          prop: "group_name",
          label: "员工小组",
          minWidth: "120"
        },
        {
          prop: "admin_name",
          label: "员工名",
          minWidth: "80"
        },
        {
          prop: "coin",
          label: "代充金币",
          minWidth: "80"
        },

        {
          prop: "DisplayId",
          label: "收款用户ID",
          minWidth: "80"
        },
        {
          prop: "app_user_name",
          label: "收款用户昵称",
          minWidth: "80"
        },
        // {
        //   prop: "corp_name",
        //   label: "员工公司",
        //   minWidth: "80"
        // },
        {
          prop: "add_time_new",
          label: "转账时间",
          minWidth: "120"
        },
      ]
    };
  },
  computed: {
    columns() {
      let result = this.columnsList.map(item => {
        const index = this.fixed_list.findIndex(itm => {
          return itm == item.prop;
        });
        if (index != -1) {
          // item.fixed = true;
          return item;
        }
      }).filter(ite => typeof ite !== 'undefined');
      return result;
    }
  },
  watch: {
    fixed_list(val) {
      if (val.length > 20) {
        this.fixed_list.shift();
      }
    }
  },

  mounted() {
    // this.search_data.info_app_user_id = this.$props.info_app_user_id ;
    this.getInitializeDate();
    this.getList();
    this.getSearchData();

  },
  methods: {
    getInitializeDate() {
      let date = new Date()
      let year = date.getFullYear().toString()
      //获取当前月份，因为月份是要从0开始，此处要加1，
      let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString()
      let start = year + '-' + month + '-01 00:00:00'
      let day = date.getDate() < 10 ? '0' + date.getDate().toString() : date.getDate().toString()
      let end = year + '-' + month + '-' + day + ' 23:59:59'
      this.value2_check = [start, end]
    },
    getSearchData() {
      // this.loading = true;
      this.$_invoke("adminUser_getSearchData", {
        corp_id: this.search_data.corp_id,
        depart_id: this.search_data.depart_id,
        group_id: this.search_data.group_id,
      })
        .then((ret) => {
          this.corp_list = ret.corp_list;
          this.depart_list = ret.depart_list;
          this.group_list = ret.group_list;
          this.app_list = ret.app_list;
          console.log(ret.sociaty_list);
          this.sociaty_list = ret.sociaty_list;
        })
        .finally(() => {
          // this.loading = false;
        });

    },
    // 点击 更改部门
    changes() {
      console.log(this.search_data.sociaty_id)
      this.getList();
      this.getSearchData();
    },
    onPick_check(cant) {
      if (!this.value2_check) {
        this.value2_check = "";
        this.search_data.start_time = "";
        this.search_data.end_time = "";
      } else {
        this.search_data.start_time = this.value2_check[0];
        this.search_data.end_time = this.value2_check[1];
      }
      if (!cant) {
        this.onSearch();
      }
    },
    //获取数据
    getList() {
      console.log(this.search_data);
      this.loading = true;
      this.$_invoke("appUserSociaty_getList", {
        page: this.page,
        page_size: this.page_size,
        ...this.search_data,
      })
        .then((ret) => {

          this.data = ret.data;
          this.count = ret.count;
          this.total_coin = ret.total_coin;
          this.total = ret.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //点击搜索按钮
    onSearch() {
      this.page = 1;
      this.rel_search_data = this.search_data;
      this.getList();
    },

    //点击重置搜索框
    onReset() {
      this.$refs.search_form.resetFields();
      this.rel_search_data = {};
    },

    //显示详情
    showInfo(row) {
      this.info_row = row;
      this.$nextTick(() => {
        this.info_visible = true;
      });
    },
    //重置固定栏位选择
    resetFixedCheck() {
      this.fixed_list = JSON.parse(JSON.stringify(this.re_fixed_list));
    },
    //清除搜索数据
    clearSearch() {
      this.search_data.app_user_id = "";
      this.search_data.admin_name = "";
      this.search_data.app_type = "";
      this.search_data.corp_id = "";
      this.search_data.depart_id = "";
      this.search_data.group_id = "";
      this.search_data.end_time = "";
      this.search_data.start_time = "";
      this.search_data.start_time = "";

      this.corp_list = [];
      this.depart_list = [];
      this.group_list = [];
      this.app_list = [];
      this.getSearchData();
      this.getList();
    },
  },
};
</script>
